module.exports = __webpack_public_path__ + "static/media/slate.32dcb4d8.obj";